export default (props, vars) => `“${props?.['student'].bio}”`;
